import { useState } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";
import Permissoes from "./Permissoes";

const ORANGE = "#FF6B2B";

export default function Configuracoes({ user, onUserUpdate, currentUser }) {
  const { theme } = useTheme();
  const [abaConfig, setAbaConfig] = useState("perfil");
  const [nome,  setNome]  = useState(user?.nome||"");
  const [email, setEmail] = useState(user?.email||"");
  const [senhaAtual,   setSenhaAtual]   = useState("");
  const [novaSenha,    setNovaSenha]    = useState("");
  const [confirmSenha, setConfirmSenha] = useState("");
  const [agencia, setAgencia] = useState(()=>{ try{return JSON.parse(localStorage.getItem("agencia_dados"))||{};}catch{return{};} });
  const [toast, setToast] = useState({msg:"",type:""});
  const [load,  setLoad]  = useState("");

  const inp = { width:"100%", boxSizing:"border-box", background:theme.bgInput, border:`1.5px solid ${theme.border}`, borderRadius:10, padding:"9px 12px", color:theme.text, fontSize:14, outline:"none", colorScheme:theme.name, fontFamily:"'Inter',sans-serif", transition:"border-color .15s" };
  const showToast=(msg,type="ok")=>{ setToast({msg,type}); setTimeout(()=>setToast({msg:"",type:""}),3500); };
  const setAg=(k,v)=>setAgencia(a=>({...a,[k]:v}));

  const salvarPerfil=async()=>{
    setLoad("perfil");
    try{ await api.put(`/users/${user._id}`,{nome,email}); const u={...user,nome,email}; localStorage.setItem("oo_user",JSON.stringify(u)); if(onUserUpdate)onUserUpdate(u); showToast("Perfil atualizado!"); }
    catch(e){ showToast(e.response?.data?.erro||"Erro ao salvar","erro"); }finally{setLoad("");}
  };

  const salvarSenha=async()=>{
    if(novaSenha!==confirmSenha) return showToast("As senhas não coincidem","erro");
    if(novaSenha.length<6) return showToast("Mínimo 6 caracteres","erro");
    setLoad("senha");
    try{ await api.put("/users/me/senha",{senhaAtual,novaSenha}); setSenhaAtual("");setNovaSenha("");setConfirmSenha(""); showToast("Senha alterada!"); }
    catch(e){ showToast(e.response?.data?.erro||"Erro","erro"); }finally{setLoad("");}
  };

  const salvarAgencia=()=>{ localStorage.setItem("agencia_dados",JSON.stringify(agencia)); showToast("Dados da agência salvos!"); };

  const ABAS_CONFIG = [
    { id:"perfil",      label:"👤 Meu Perfil",    show: true },
    { id:"senha",       label:"🔒 Senha",          show: true },
    { id:"agencia",     label:"🏢 Agência",        show: true },
    { id:"permissoes",  label:"🔐 Permissões",     show: currentUser?.role==="admin" },
  ].filter(a=>a.show);

  return (
    <div style={{ padding:"24px 28px", fontFamily:"'Inter',-apple-system,sans-serif", background:theme.bg, minHeight:"100vh" }}>
      {toast.msg&&(
        <div style={{ position:"fixed", bottom:24, right:24, background:(toast.type==="erro"?"#ef4444":"#10b981")+"22", border:`1px solid ${(toast.type==="erro"?"#ef4444":"#10b981")}44`, borderRadius:10, padding:"12px 20px", color:toast.type==="erro"?"#ef4444":"#10b981", fontSize:13, fontWeight:600, zIndex:2000 }}>
          {toast.type==="erro"?"❌":"✅"} {toast.msg}
        </div>
      )}

      {/* Abas */}
      <div style={{ display:"flex", gap:4, marginBottom:24, borderBottom:`1px solid ${theme.border}`, paddingBottom:0 }}>
        {ABAS_CONFIG.map(a=>(
          <button key={a.id} onClick={()=>setAbaConfig(a.id)} style={{ padding:"10px 18px", borderRadius:"10px 10px 0 0", fontSize:13, fontWeight:abaConfig===a.id?700:400, cursor:"pointer", border:`1px solid ${abaConfig===a.id?theme.border:theme.border}`, borderBottom:abaConfig===a.id?`2px solid ${ORANGE}`:`1px solid transparent`, background:abaConfig===a.id?theme.bgCard:"transparent", color:abaConfig===a.id?ORANGE:theme.textMuted, fontFamily:"'Inter',sans-serif", marginBottom:"-1px" }}>
            {a.label}
          </button>
        ))}
      </div>

      {/* Permissões — renderiza o componente dedicado */}
      {abaConfig==="permissoes" && <Permissoes currentUser={currentUser||user}/>}

      {/* Perfil */}
      {abaConfig==="perfil" && (
        <div style={{ maxWidth:560 }}>
          <h3 style={{ margin:"0 0 20px", fontSize:18, fontWeight:700, color:theme.text }}>Meu Perfil</h3>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:20 }}>
            {[["Nome completo","nome",nome,setNome],["Email","email",email,setEmail]].map(([label,key,val,setter])=>(
              <div key={key}>
                <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:5, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
                <input value={val} onChange={e=>setter(e.target.value)} style={inp}
                  onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
              </div>
            ))}
          </div>
          <button onClick={salvarPerfil} disabled={load==="perfil"} style={{ background:`linear-gradient(135deg,${ORANGE},#FF9A5C)`, border:"none", borderRadius:10, padding:"11px 24px", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"'Inter',sans-serif", opacity:load==="perfil"?.7:1 }}>
            {load==="perfil"?"Salvando...":"Salvar perfil"}
          </button>
        </div>
      )}

      {/* Senha */}
      {abaConfig==="senha" && (
        <div style={{ maxWidth:560 }}>
          <h3 style={{ margin:"0 0 20px", fontSize:18, fontWeight:700, color:theme.text }}>Alterar Senha</h3>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:14, marginBottom:20 }}>
            {[["Senha atual","senhaAtual",senhaAtual,setSenhaAtual],["Nova senha","novaSenha",novaSenha,setNovaSenha],["Confirmar","confirmSenha",confirmSenha,setConfirmSenha]].map(([label,key,val,setter])=>(
              <div key={key}>
                <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:5, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
                <input type="password" value={val} onChange={e=>setter(e.target.value)} style={inp}
                  onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
              </div>
            ))}
          </div>
          <button onClick={salvarSenha} disabled={load==="senha"} style={{ background:"#6366f1", border:"none", borderRadius:10, padding:"11px 24px", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"'Inter',sans-serif", opacity:load==="senha"?.7:1 }}>
            {load==="senha"?"Alterando...":"Alterar senha"}
          </button>
        </div>
      )}

      {/* Agência */}
      {abaConfig==="agencia" && (
        <div style={{ maxWidth:640 }}>
          <h3 style={{ margin:"0 0 20px", fontSize:18, fontWeight:700, color:theme.text }}>Dados da Agência</h3>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:20 }}>
            {[["Nome da agência","nome","Agência Optimus"],["CNPJ","cnpj","00.000.000/0001-00"],["Telefone","telefone","(15) 99999-9999"],["Email comercial","emailComercial","contato@agenciaoptimus.net.br"],["Site","site","agenciaoptimus.net.br"],["Instagram","instagram","@agenciaoptimus"],["Cidade / Estado","cidade","Sorocaba, SP"],["Endereço","endereco","Rua Exemplo, 123"]].map(([label,key,placeholder])=>(
              <div key={key}>
                <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:5, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
                <input value={agencia[key]||""} onChange={e=>setAg(key,e.target.value)} placeholder={placeholder} style={inp}
                  onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
              </div>
            ))}
          </div>
          <button onClick={salvarAgencia} style={{ background:"#10b981", border:"none", borderRadius:10, padding:"11px 24px", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"'Inter',sans-serif" }}>
            Salvar dados
          </button>
        </div>
      )}
    </div>
  );
}
